export const crmAppLanguageEnglish = {
    'ra-audit-log': {
        // TODO: fix error in console when "action" has nested object instead of string
        // move translations from "adzz.timeline" here
        record_event: {
            comment: 'New published comment',
            Decline: '',
            Approve: '',
            PostChangeStatus: '',
            PostLinkCheck: '',
            copyscape: '',
            update: '',
        },
    },
    ra: {
        action: {
            edit: '',
        },
    },
    adzz: {
        auth: {
            token_expired: 'Token expired. Please log in again.',
        },
        resources: {
            v1_Posts: {
                fields: {
                    new_ContentOrderStatus: 'Content Status',
                    new_PostStatus: 'Post Status',
                    new_OutreachStatus: 'Outreach Status',
                    new_TextHTMLbody: 'body',
                    writer_id: 'writer',
                    new_name: 'Source URL',
                    approver_id: 'To Be Approved By',
                    requestedfrom_id: 'Requested From',
                    supplier_id: 'Supplier',
                    new_Supplierprice: 'Supplier Price',
                    new_ContentCost: 'Content Cost',
                    new_UploadPrice: 'Upload Price',
                    new_TotalPrice: 'Total Price',
                },
            },
        },
        timeline: {
            Decline: {
                with_comment: 'Declined with comment',
                without_comment: 'Declined'
            },
            Approve: {
                with_comment: 'Approved with comment',
                without_comment: 'Approved'
            },
            PostLinkCheck: 'Post Link Check Succeeded',
            PostChangeStatus: 'Updated',
            update: 'Updated',
            copyscape: {
                success: '%{allpercentmatched}% copied text',
                error: 'Post could not be checked: %{error}',
            }
        },
        notification: {
            update: {
                success: '%{name} updated successfully',
                error: 'An error occurred updating %{name}'
            }
        }
    },
};
